export enum EUserType {
  HUBERT = 'hubert',
  HUBERT_SUPER_USER = 'super-admin',
  HUBERT_SUPPORT = 'support',
  HUBERT_SALES = 'sales',
  HUBERT_SCORER = 'scorer',

  RECRUITER = 'recruiter',
  RECRUITER_ADMIN = 'recruiter-admin',
  RECRUITER_USER = 'recruiter-user',
  ANY = 'any',
}

export const UserGroup = {
  HUBERT: [
    EUserType.ANY,
    EUserType.HUBERT,
    EUserType.HUBERT_SUPER_USER,
    EUserType.HUBERT_SUPER_USER,
    EUserType.HUBERT_SALES,
    EUserType.HUBERT_SCORER,
  ],
  RECRUITERS: [EUserType.ANY, EUserType.RECRUITER, EUserType.RECRUITER_ADMIN, EUserType.RECRUITER_USER],
};
